import { ArticlesVisibilitySettingsBuilder } from './../../common/articles-visibility/articles-visibility-settings.builder';
var TicketMultilingualSettingsBuilder = /** @class */ (function () {
    function TicketMultilingualSettingsBuilder() {
        this.ticketMultilingualSettings = {
            relatedArticlesScope: new ArticlesVisibilitySettingsBuilder().build()
        };
    }
    TicketMultilingualSettingsBuilder.prototype.withRelatedArticlesScope = function (relatedArticlesScope) {
        this.ticketMultilingualSettings.relatedArticlesScope = relatedArticlesScope;
        return this;
    };
    TicketMultilingualSettingsBuilder.prototype.build = function () {
        return this.ticketMultilingualSettings;
    };
    return TicketMultilingualSettingsBuilder;
}());
export { TicketMultilingualSettingsBuilder };
//# sourceMappingURL=ticket-multilingual-settings.builder.js.map